module.exports = __webpack_public_path__ + "static/pauserecording3-648c5217be0ee045c9872fd107593cee.png";